module.exports = __webpack_public_path__ + "static/img/demo_3_or.fc21a47e.png";